/* =========================================================================
   RP ROYAL PRINCE SPORTS — THEME JS
   Vanilla JS. No dependencies. Progressive enhancement over real <form> posts.
   ========================================================================= */
(function () {
  "use strict";

  var RP = window.RP = window.RP || {};
  RP.routes = window.RP_ROUTES || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart.js", predictive_search: "/search/suggest.json" };

  /* ---------------- helpers ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function money(cents) {
    var val = (cents / 100).toFixed(2);
    var parts = val.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (window.RP_MONEY_FORMAT || "₹{{amount}}").replace("{{amount}}", parts[0]);
  }

  /* ================================================================
     GENERIC PANEL CONTROLLER (drawers, modals, mega menu, overlays)
     Trigger: [data-open-panel="panelId"]  Close: [data-close-panel]
     ================================================================ */
  var scrim = qs("#scrim");
  var lastFocused = null;

  // Lock page scroll WITHOUT causing a horizontal layout jump.
  // Hiding the scrollbar changes the viewport width, which shifts the whole
  // page sideways — so we compensate with padding equal to the scrollbar width.
  function lockScroll() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + "px";
    document.documentElement.style.overflow = "hidden";
  }
  function unlockScroll() {
    document.documentElement.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  // The mega menu is a hover-driven dropdown, NOT a modal surface: it must not
  // lock scroll, dim the page, or steal focus.
  function isLightPanel(panel) {
    return panel.classList.contains("mega-menu");
  }

  function openPanel(id) {
    var panel = document.getElementById(id);
    if (!panel) return;
    var light = isLightPanel(panel);
    if (!light) {
      lastFocused = document.activeElement;
      if (scrim) scrim.classList.add("is-visible");
      lockScroll();
      var focusable = panel.querySelector("input, button, a");
      if (focusable) setTimeout(function () { focusable.focus(); }, 150);
    }
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    qsa('[data-open-panel="' + id + '"]').forEach(function (t) { t.setAttribute("aria-expanded", "true"); });
  }

  function closeAllPanels() {
    var hadModal = false;
    qsa(".drawer.is-open, .modal.is-open, .mega-menu.is-open, .search-overlay.is-open, .nav-drawer.is-open, .lightbox.is-open").forEach(function (p) {
      if (!isLightPanel(p)) hadModal = true;
      p.classList.remove("is-open");
      p.setAttribute("aria-hidden", "true");
    });
    qsa('[data-open-panel][aria-expanded="true"]').forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
    if (scrim) scrim.classList.remove("is-visible");
    unlockScroll();
    if (hadModal && lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
    lastFocused = null;
  }

  // Close only the mega menu (used on mouseleave) so it can't fight with drawers.
  function closeMegaMenu() {
    qsa(".mega-menu.is-open").forEach(function (p) {
      p.classList.remove("is-open");
      p.setAttribute("aria-hidden", "true");
    });
    qsa('[data-open-panel="mega-menu"]').forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
  }
  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-open-panel]");
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute("data-open-panel");
      var panel = document.getElementById(id);
      if (panel && (panel.classList.contains("is-open"))) { closeAllPanels(); }
      else { openPanel(id); }
      return;
    }
    if (e.target.closest("[data-close-panel]") || e.target === scrim) {
      closeAllPanels();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAllPanels();
  });

  /* ================================================================
     MOBILE NAV DRAWER — nested submenus
     ================================================================ */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-toggle-submenu]");
    if (!t) return;
    var sub = document.getElementById(t.getAttribute("data-toggle-submenu"));
    if (!sub) return;
    var open = sub.classList.toggle("is-open");
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* ================================================================
     MEGA MENU — hover (desktop) + click fallback, keep prior generic
     open/close via data-open-panel already wired above.
     ================================================================ */
  var megaWrap = qs("[data-mega-wrap]");
  if (megaWrap && window.matchMedia("(hover:hover) and (pointer:fine)").matches) {
    var closeTimer;
    megaWrap.addEventListener("mouseenter", function () {
      clearTimeout(closeTimer);
      openPanel("mega-menu");
    });
    megaWrap.addEventListener("mouseleave", function () {
      closeTimer = setTimeout(closeMegaMenu, 160);
    });
    var megaPanel = document.getElementById("mega-menu");
    if (megaPanel) {
      megaPanel.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
      megaPanel.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(closeMegaMenu, 160);
      });
    }
  }

  /* ================================================================
     HEADER SCROLL STATE
     ================================================================ */
  var header = qs(".site-header");
  if (header) {
    // rAF-throttled (not debounced): debouncing made the state lag behind the
    // scroll and caused visible flicker on the sticky/backdrop-filtered header.
    var scrollTicking = false;
    var lastScrolled = null;
    function updateHeaderState() {
      var scrolled = window.scrollY > 12;
      if (scrolled !== lastScrolled) {
        lastScrolled = scrolled;
        header.classList.toggle("is-scrolled", scrolled);
      }
      scrollTicking = false;
    }
    document.addEventListener("scroll", function () {
      if (!scrollTicking) {
        scrollTicking = true;
        requestAnimationFrame(updateHeaderState);
      }
    }, { passive: true });
    updateHeaderState();
  }

  /* ================================================================
     ACCORDION
     ================================================================ */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest(".accordion-trigger");
    if (!trig) return;
    var item = trig.closest(".accordion-item");
    var panel = item.querySelector(".accordion-panel");
    var opening = !item.classList.contains("is-open");
    item.classList.toggle("is-open", opening);
    trig.setAttribute("aria-expanded", opening ? "true" : "false");
    panel.style.maxHeight = opening ? panel.scrollHeight + "px" : "0px";
  });

  /* ================================================================
     REVEAL ON SCROLL
     ================================================================ */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });
    qsa(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    qsa(".reveal").forEach(function (el) { el.classList.add("in-view"); });
  }

  /* ================================================================
     CART — Section Rendering API
     ================================================================ */
  var cartDrawerRoot = qs("#cart-drawer-root");

  function refreshCartFragment(html) {
    if (!cartDrawerRoot) return;
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    var incoming = tmp.querySelector("#cart-drawer-root");
    if (incoming) {
      cartDrawerRoot.innerHTML = incoming.innerHTML;
      var counter = qs("#cart-drawer-count", cartDrawerRoot);
      var count = counter ? counter.getAttribute("data-count") : null;
      if (count !== null) updateCartBubble(parseInt(count, 10));
    }
  }
  function updateCartBubble(count) {
    qsa(".cart-count").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hidden", count === 0);
    });
  }
  function cartTypeIsPage() {
    return document.body.getAttribute("data-cart-type") === "page";
  }
  function goToCartOrOpenDrawer() {
    if (cartTypeIsPage()) { window.location.href = RP.routes.cart.replace(".js", ""); }
    else { openPanel("cart-drawer"); }
  }
  function cartRequest(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  // Add to cart: any form[data-cart-form] OR quick-add button [data-quick-add]
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    submitAddToCart(form, form.querySelector('[type="submit"]'));
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-variant-id");
    if (!id) return;
    setLoading(btn, true);
    cartRequest(RP.routes.cart_add, { items: [{ id: id, quantity: 1 }], sections: "cart-drawer", sections_url: window.location.pathname })
      .then(function (data) {
        if (data.sections && data.sections["cart-drawer"]) refreshCartFragment(data.sections["cart-drawer"]);
        goToCartOrOpenDrawer();
      })
      .catch(function (err) { announce(err.description || "Couldn't add that to your bag."); })
      .finally(function () { setLoading(btn, false); });
  });

  function submitAddToCart(form, btn) {
    var fd = new FormData(form);
    fd.append("sections", "cart-drawer");
    fd.append("sections_url", window.location.pathname);
    setLoading(btn, true);
    fetch(RP.routes.cart_add, { method: "POST", headers: { Accept: "application/json" }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        if (res.data.sections && res.data.sections["cart-drawer"]) refreshCartFragment(res.data.sections["cart-drawer"]);
        goToCartOrOpenDrawer();
      })
      .catch(function (err) { announce(err.description || "That item is unavailable right now."); })
      .finally(function () { setLoading(btn, false); });
  }

  // Quantity + remove inside cart drawer (event delegation)
  document.addEventListener("click", function (e) {
    var stepper = e.target.closest("[data-cart-qty-step]");
    if (stepper) {
      var wrap = stepper.closest(".qty-input");
      var input = wrap.querySelector("input");
      var dir = stepper.getAttribute("data-cart-qty-step") === "up" ? 1 : -1;
      var next = Math.max(0, parseInt(input.value || "1", 10) + dir);
      input.value = next;
      changeLine(stepper.getAttribute("data-line"), next);
      return;
    }
    var remove = e.target.closest("[data-cart-remove]");
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute("data-line"), 0);
    }
  });
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-qty-input]");
    if (!input) return;
    var val = Math.max(0, parseInt(input.value || "0", 10));
    changeLine(input.getAttribute("data-line"), val);
  });

  function changeLine(line, quantity) {
    cartRequest(RP.routes.cart_change, { line: line, quantity: quantity, sections: "cart-drawer", sections_url: window.location.pathname })
      .then(function (data) {
        if (data.sections && data.sections["cart-drawer"]) refreshCartFragment(data.sections["cart-drawer"]);
      })
      .catch(function () { announce("Couldn't update your bag. Refresh and try again."); });
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle("is-loading", loading);
    btn.disabled = loading;
  }
  function announce(msg) {
    var el = qs("#rp-announcer");
    if (el) el.textContent = msg;
  }

  /* ================================================================
     PREDICTIVE SEARCH
     ================================================================ */
  var searchInput = qs("#predictive-search-input");
  if (searchInput) {
    var resultsBox = qs("#predictive-search-results");
    searchInput.addEventListener("input", debounce(function () {
      var val = searchInput.value.trim();
      if (val.length < 2) { resultsBox.innerHTML = ""; resultsBox.classList.add("hidden"); return; }
      fetch(RP.routes.predictive_search + "?q=" + encodeURIComponent(val) + "&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last")
        .then(function (r) { return r.json(); })
        .then(function (data) { renderPredictive(data, resultsBox); })
        .catch(function () {});
    }, 220));
  }
  function renderPredictive(data, box) {
    var r = data.resources ? data.resources.results : {};
    var products = r.products || [];
    var collections = r.collections || [];
    var queries = r.queries || [];
    if (!products.length && !collections.length) {
      box.innerHTML = '<p class="text-ink60" style="padding:20px 0">No results yet — try a product, collection, or willow grade.</p>';
      box.classList.remove("hidden");
      return;
    }
    var html = "";
    if (queries.length) {
      html += '<div class="search-suggest" style="margin-bottom:20px">' + queries.map(function (q) {
        return '<a class="chip" href="' + q.url + '">' + q.text + "</a>";
      }).join("") + "</div>";
    }
    if (collections.length) {
      html += '<p class="eyebrow eyebrow--blue">Collections</p><div class="grid-2" style="margin-bottom:24px">' + collections.map(function (c) {
        return '<a href="' + c.url + '" class="chip">' + c.title + "</a>";
      }).join("") + "</div>";
    }
    if (products.length) {
      html += '<p class="eyebrow eyebrow--blue">Products</p><div class="product-grid">' + products.map(function (p) {
        return '<a href="' + p.url + '" class="product-card">' +
          '<span class="product-card__media"><img src="' + (p.featured_image ? p.featured_image.url : "") + '" alt="' + p.title + '" loading="lazy"></span>' +
          '<span class="product-card__body"><span class="product-card__title">' + p.title + '</span>' +
          '<span class="price"><span class="price__regular">' + money(p.price) + "</span></span></span></a>";
      }).join("") + "</div>";
    }
    box.innerHTML = html;
    box.classList.remove("hidden");
  }

  /* ================================================================
     PRODUCT PAGE — variant picker
     ================================================================ */
  var pdpForm = qs("[data-product-form]");
  if (pdpForm) {
    var productJsonEl = qs("[data-product-json]", pdpForm.closest("[data-product-root]"));
    var product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    var root = pdpForm.closest("[data-product-root]");

    function findVariant(selected) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }
    function getSelectedOptions() {
      return qsa("[data-option-index]", root).map(function (group) {
        var active = group.querySelector(".is-active");
        return active ? active.getAttribute("data-option-value") : null;
      });
    }
    function updateForVariant(variant) {
      var idInput = qs('input[name="id"]', pdpForm);
      var submitBtn = qs('[data-atc-button]', pdpForm);
      var priceWrap = qs("[data-price]", root);
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? (submitBtn.getAttribute("data-label") || "Add to Bag") : "Sold Out";
      }
      if (priceWrap) {
        var reg = qs(".price__regular", priceWrap);
        if (reg) reg.textContent = money(variant.price);
        var cmp = qs(".price__compare", priceWrap);
        if (cmp) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            cmp.textContent = money(variant.compare_at_price);
            cmp.classList.remove("hidden");
          } else { cmp.classList.add("hidden"); }
        }
      }
      // Switch the gallery to this variant's media (by media id) rather than
      // swapping an <img> src, so thumbs/lightbox stay in sync.
      if (window.RPGallery) {
        // Find a colour-like option on this variant and filter the gallery to it
        var colourVal = null;
        if (product && product.options) {
          product.options.forEach(function (optName, i) {
            var n = String(optName).toLowerCase();
            if (n.indexOf("colour") > -1 || n.indexOf("color") > -1 || n.indexOf("shade") > -1) {
              colourVal = variant.options[i];
            }
          });
        }
        if (colourVal && window.RPGallery.filterByOption) {
          window.RPGallery.filterByOption(colourVal);
        }
        if (variant.featured_media) {
          window.RPGallery.showByMediaId(variant.featured_media.id);
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
    document.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-option-value]");
      if (!opt || !root.contains(opt)) return;
      var group = opt.closest("[data-option-index]");
      qsa("[data-option-value]", group).forEach(function (o) { o.classList.remove("is-active"); o.setAttribute("aria-pressed", "false"); });
      opt.classList.add("is-active");
      opt.setAttribute("aria-pressed", "true");
      updateForVariant(findVariant(getSelectedOptions()));
    });


    // Sticky ATC visibility
    var atcAnchor = qs("[data-atc-anchor]", root);
    var stickyAtc = qs("#sticky-atc");
    if (atcAnchor && stickyAtc && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        stickyAtc.classList.toggle("is-visible", show);
        // Floating buttons read this to lift clear of the Add to Bag bar
        document.body.classList.toggle("atc-visible", show);
      }, { rootMargin: "-120px 0px 0px 0px" }).observe(atcAnchor);
    }
  }

  /* ================================================================
     WISHLIST (localStorage, front-end only)
     ================================================================ */
  var WISHLIST_KEY = "rp_wishlist";
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; } }
  function setWishlist(list) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); updateWishlistUI(); }
  function updateWishlistUI() {
    var list = getWishlist();
    qsa(".wishlist-count").forEach(function (el) { el.textContent = list.length; el.classList.toggle("hidden", list.length === 0); });
    qsa("[data-wishlist-toggle]").forEach(function (btn) {
      btn.classList.toggle("is-active", list.some(function (i) { return i.id === btn.getAttribute("data-product-id"); }));
    });
    renderWishlistDrawer(list);
  }
  function renderWishlistDrawer(list) {
    var body = qs("#wishlist-drawer-items");
    if (!body) return;
    if (!list.length) {
      body.innerHTML = '<div class="empty-state"><p class="h-3 text-navy" style="margin-bottom:8px">Nothing saved yet</p><p class="text-ink60">Tap the heart on any product to save it here.</p></div>';
      return;
    }
    body.innerHTML = list.map(function (item) {
      return '<div class="cart-line"><a href="' + item.url + '" class="cart-line__media"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>' +
        '<div style="flex:1;min-width:0"><a href="' + item.url + '" class="cart-line__title">' + item.title + '</a>' +
        '<p class="cart-line__variant">' + item.price + '</p>' +
        '<button type="button" class="line-remove" data-wishlist-toggle data-product-id="' + item.id + '" style="margin-top:8px;background:transparent;border:0;padding:0">Remove</button></div></div>';
    }).join("");
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-product-id");
    var list = getWishlist();
    var idx = list.findIndex(function (i) { return i.id === id; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: id,
        title: btn.getAttribute("data-product-title") || "",
        url: btn.getAttribute("data-product-url") || "#",
        image: btn.getAttribute("data-product-image") || "",
        price: btn.getAttribute("data-product-price") || ""
      });
    }
    setWishlist(list);
  });
  updateWishlistUI();

  /* ================================================================
     PRODUCT RECOMMENDATIONS — fetch + inject (native Shopify endpoint)
     ================================================================ */
  qsa("[data-recommendations]").forEach(function (el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var incoming = tmp.querySelector("[data-recommendations]");
        if (incoming && incoming.innerHTML.trim()) {
          el.innerHTML = incoming.innerHTML;
        }
      })
      .catch(function () {});
  });

  /* ================================================================
     PRODUCT GALLERY + LIGHTBOX (zoom / pan / keyboard / swipe)
     ================================================================ */
  var galleryEl = qs("[data-gallery]");
  if (galleryEl) {
    var slides = qsa("[data-gallery-slide]", galleryEl);
    var thumbs = qsa("[data-gallery-thumb]", galleryEl);

    function showSlide(index) {
      slides.forEach(function (s) {
        s.classList.toggle("is-active", s.getAttribute("data-gallery-slide") === String(index));
      });
      thumbs.forEach(function (t) {
        var on = t.getAttribute("data-gallery-thumb") === String(index);
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      // Pause any playing HTML5 video in non-active slides
      qsa("video", galleryEl).forEach(function (v) {
        if (!v.closest(".pdp-gallery__slide.is-active") && !v.paused) v.pause();
      });
    }

    // ---- Filter the gallery by a variant option value (e.g. colour) ----
    // Any media whose ALT TEXT contains the option value is treated as belonging
    // to it. Set image alt text to "Red", "White", "Pink" etc. in Shopify.
    // No match -> show every image (the "nothing selected" case).
    function filterByOption(value) {
      var v = (value || "").trim().toLowerCase();
      var matched = 0;

      if (v) {
        matched = slides.filter(function (s) {
          return (s.getAttribute("data-media-alt") || "").indexOf(v) > -1;
        }).length;
      }

      var showAll = !v || matched === 0;

      slides.forEach(function (s) {
        var alt = s.getAttribute("data-media-alt") || "";
        var on = showAll || alt.indexOf(v) > -1;
        s.classList.toggle("is-filtered-out", !on);
      });
      thumbs.forEach(function (t) {
        var alt = t.getAttribute("data-media-alt") || "";
        var on = showAll || alt.indexOf(v) > -1;
        t.classList.toggle("is-filtered-out", !on);
      });

      // Jump to the first still-visible slide
      var firstVisible = slides.filter(function (s) { return !s.classList.contains("is-filtered-out"); })[0];
      if (firstVisible) showSlide(parseInt(firstVisible.getAttribute("data-gallery-slide"), 10));
    }

    window.RPGallery = {
      show: showSlide,
      filterByOption: filterByOption,
      showByMediaId: function (mediaId) {
        var match = slides.filter(function (s) { return s.getAttribute("data-media-id") === String(mediaId); })[0];
        if (match) showSlide(parseInt(match.getAttribute("data-gallery-slide"), 10));
      }
    };

    galleryEl.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-gallery-thumb]");
      if (thumb) showSlide(parseInt(thumb.getAttribute("data-gallery-thumb"), 10));
    });

    // Swipe on the main stage (mobile)
    var stage = qs("[data-gallery-main]", galleryEl);
    if (stage) {
      var sx = 0, sy = 0, swiping = false;
      stage.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
      }, { passive: true });
      stage.addEventListener("touchend", function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        var activeIdx = slides.findIndex(function (s) { return s.classList.contains("is-active"); });
        var next = dx < 0 ? activeIdx + 1 : activeIdx - 1;
        if (next >= 0 && next < slides.length) showSlide(next);
      }, { passive: true });
    }
  }

  var lightbox = qs("#product-lightbox");
  if (lightbox) {
    var lbFigures = qsa("[data-lightbox-slide]", lightbox);
    var lbCounter = qs("[data-lightbox-counter]", lightbox);
    var lbIndex = 0;
    var zoom = 1, panX = 0, panY = 0;

    function applyTransform(img) {
      img.style.transform = "scale(" + zoom + ") translate(" + panX + "px," + panY + "px)";
      img.classList.toggle("is-zoomed", zoom > 1);
    }
    function resetZoom() {
      zoom = 1; panX = 0; panY = 0;
      lbFigures.forEach(function (f) {
        var img = qs("img", f);
        if (img) { img.style.transform = ""; img.classList.remove("is-zoomed"); }
      });
    }
    function showLbSlide(i) {
      if (!lbFigures.length) return;
      lbIndex = (i + lbFigures.length) % lbFigures.length;
      lbFigures.forEach(function (f, idx) { f.classList.toggle("is-active", idx === lbIndex); });
      if (lbCounter) lbCounter.textContent = (lbIndex + 1) + " / " + lbFigures.length;
      resetZoom();
      qsa(".lightbox__nav", lightbox).forEach(function (n) {
        n.style.display = lbFigures.length > 1 ? "grid" : "none";
      });
    }

    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-lightbox-open]");
      if (opener) {
        e.preventDefault();
        // Map media index -> index among image-only lightbox figures
        var wanted = opener.getAttribute("data-lightbox-index");
        var target = lbFigures.findIndex(function (f) { return f.getAttribute("data-lightbox-slide") === wanted; });
        showLbSlide(target > -1 ? target : 0);
        openPanel("product-lightbox");
        return;
      }
      if (e.target.closest("[data-lightbox-next]")) { showLbSlide(lbIndex + 1); return; }
      if (e.target.closest("[data-lightbox-prev]")) { showLbSlide(lbIndex - 1); return; }
    });

    document.addEventListener("keydown", function (e) {
      if (!lightbox.classList.contains("is-open")) return;
      if (e.key === "ArrowRight") showLbSlide(lbIndex + 1);
      if (e.key === "ArrowLeft") showLbSlide(lbIndex - 1);
      if (e.key === "Escape") { resetZoom(); }
    });

    // Clicking the dark backdrop (not the image) closes the viewer
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox || e.target.classList.contains("lightbox__stage")) {
        resetZoom();
        closeAllPanels();
      }
    });
    // Any close button inside the viewer
    lightbox.addEventListener("click", function (e) {
      if (e.target.closest("[data-close-panel]")) { resetZoom(); }
    });

    // Wheel / pinch zoom + drag pan
    lightbox.addEventListener("wheel", function (e) {
      if (!lightbox.classList.contains("is-open")) return;
      e.preventDefault();
      var img = qs(".lightbox__figure.is-active img", lightbox);
      if (!img) return;
      zoom = Math.min(4, Math.max(1, zoom + (e.deltaY > 0 ? -0.2 : 0.2)));
      if (zoom === 1) { panX = 0; panY = 0; }
      applyTransform(img);
    }, { passive: false });

    var dragging = false, lastX = 0, lastY = 0;
    lightbox.addEventListener("pointerdown", function (e) {
      var img = e.target.closest(".lightbox__figure.is-active img");
      if (!img || zoom === 1) return;
      dragging = true; lastX = e.clientX; lastY = e.clientY;
      img.setPointerCapture && img.setPointerCapture(e.pointerId);
    });
    lightbox.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var img = qs(".lightbox__figure.is-active img", lightbox);
      if (!img) return;
      panX += (e.clientX - lastX) / zoom;
      panY += (e.clientY - lastY) / zoom;
      lastX = e.clientX; lastY = e.clientY;
      applyTransform(img);
    });
    lightbox.addEventListener("pointerup", function () { dragging = false; });
    lightbox.addEventListener("pointercancel", function () { dragging = false; });

    // Double-click / double-tap to toggle zoom
    lightbox.addEventListener("dblclick", function (e) {
      var img = e.target.closest(".lightbox__figure.is-active img");
      if (!img) return;
      zoom = zoom > 1 ? 1 : 2.5;
      panX = 0; panY = 0;
      applyTransform(img);
    });
  }

  /* ================================================================
     BAT FINDER QUIZ — real collection/product data, no fake results
     ================================================================ */
  var finderRoot = qs("[data-bat-finder]");
  if (finderRoot) {
    var finderAnswers = {};
    var finderSteps = qsa("[data-finder-step]", finderRoot);
    var finderDots = qsa("[data-finder-dot]", finderRoot);
    var finderLoading = qs("[data-finder-loading]", finderRoot);
    var finderResults = qs("[data-finder-results]", finderRoot);

    function finderGoToStep(stepId) {
      finderSteps.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-finder-step") === stepId); });
      finderDots.forEach(function (d) {
        var n = d.getAttribute("data-finder-dot");
        d.classList.toggle("is-done", parseInt(n, 10) < parseInt(stepId, 10));
        d.classList.toggle("is-active", n === stepId);
      });
      finderLoading.classList.add("hidden");
      finderResults.classList.remove("is-active");
    }

    finderRoot.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-finder-key]");
      if (opt) {
        var key = opt.getAttribute("data-finder-key");
        var value = opt.getAttribute("data-finder-value");
        finderAnswers[key] = value;
        var currentStep = opt.closest("[data-finder-step]").getAttribute("data-finder-step");
        var nextStep = String(parseInt(currentStep, 10) + 1);
        if (key === "budget") {
          runFinderSearch();
        } else {
          finderGoToStep(nextStep);
        }
        return;
      }
      var back = e.target.closest("[data-finder-back]");
      if (back) {
        var cur = back.closest("[data-finder-step]").getAttribute("data-finder-step");
        finderGoToStep(String(parseInt(cur, 10) - 1));
        return;
      }
      var restart = e.target.closest("[data-finder-restart]");
      if (restart) {
        finderAnswers = {};
        finderGoToStep("1");
      }
    });

    function moneyFromDecimal(decimalStr) {
      var cents = Math.round(parseFloat(decimalStr) * 100);
      return money(cents);
    }

    function budgetRange(budget) {
      if (budget === "under-5000") return { min: 0, max: 5000 };
      if (budget === "5000-15000") return { min: 5000, max: 15000 };
      return { min: 15000, max: Infinity };
    }

    function runFinderSearch() {
      finderSteps.forEach(function (s) { s.classList.remove("is-active"); });
      finderLoading.classList.remove("hidden");
      finderDots.forEach(function (d) { d.classList.add("is-done"); });

      var collectionUrl = finderRoot.getAttribute("data-collection-" + finderAnswers.level) || "/collections/all";
      var range = budgetRange(finderAnswers.budget);

      fetch(collectionUrl + "/products.json?limit=24")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return p.variants && p.variants.some(function (v) { return v.available; });
          });
          var inBudget = products.filter(function (p) {
            var v = p.variants[0];
            var price = parseFloat(v.price);
            return price >= range.min && price <= range.max;
          });
          var chosen = inBudget.length ? inBudget : products.slice().sort(function (a, b) {
            return Math.abs(parseFloat(a.variants[0].price) - range.min) - Math.abs(parseFloat(b.variants[0].price) - range.min);
          });
          renderFinderResults(chosen.slice(0, 3), collectionUrl, inBudget.length > 0);
        })
        .catch(function () {
          renderFinderResults([], collectionUrl, false);
        });
    }

    function renderFinderResults(products, collectionUrl, exactBudgetMatch) {
      finderLoading.classList.add("hidden");
      finderResults.classList.add("is-active");

      var headline = qs("[data-finder-headline]", finderResults);
      var levelLabel = { beginner: "Getting Started", club: "Club & School Level", advanced: "State Level & Above" }[finderAnswers.level] || "You";
      headline.textContent = (finderAnswers.style || "Your Game") + " · " + levelLabel;

      var grid = qs("[data-finder-products]", finderResults);
      if (!products.length) {
        grid.innerHTML = '<p class="finder-empty">Nothing in stock in that exact range right now — explore the full collection below.</p>';
      } else {
        grid.innerHTML = products.map(function (p) {
          var v = p.variants[0];
          var img = p.images && p.images[0] ? p.images[0].src : "";
          return '<div class="product-card"><a href="/products/' + p.handle + '" class="product-card__media">' +
            (img ? '<img class="is-primary" src="' + img + '&width=600" alt="' + (p.title || "").replace(/"/g, "") + '" loading="lazy">' : '') +
            '</a><div class="product-card__body"><h3 class="product-card__title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
            '<div class="product-card__price"><span class="price"><span class="price__regular">' + moneyFromDecimal(v.price) + '</span></span></div></div></div>';
        }).join("");
        if (!exactBudgetMatch) {
          grid.insertAdjacentHTML("afterbegin", '<p class="finder-empty" style="grid-column:1/-1;margin-bottom:4px">Closest matches to your budget:</p>');
        }
      }

      var cta = qs("[data-finder-cta]", finderResults);
      cta.href = collectionUrl;
    }
  }

  /* ================================================================
     RECENTLY VIEWED — localStorage, real product data captured on PDP
     ================================================================ */
  var RECENTLY_VIEWED_KEY = "rp_recently_viewed";
  var pdpRoot = qs("[data-product-root]");
  if (pdpRoot) {
    var rvDataEl = qs("[data-recently-viewed-capture]");
    if (rvDataEl) {
      try {
        var entry = JSON.parse(rvDataEl.textContent);
        var list = [];
        try { list = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) { list = []; }
        list = list.filter(function (i) { return i.id !== entry.id; });
        list.unshift(entry);
        list = list.slice(0, 8);
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
      } catch (e) {}
    }
  }
  var rvRail = qs("[data-recently-viewed-rail]");
  if (rvRail) {
    var rvList = [];
    try { rvList = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) { rvList = []; }
    var currentId = rvRail.getAttribute("data-current-product-id");
    rvList = rvList.filter(function (i) { return String(i.id) !== String(currentId); });
    if (rvList.length) {
      rvRail.closest(".recently-viewed").classList.add("has-items");
      var track = qs("[data-recently-viewed-track]", rvRail);
      track.innerHTML = rvList.map(function (item) {
        return '<div class="product-card"><a href="' + item.url + '" class="product-card__media">' +
          (item.image ? '<img class="is-primary" src="' + item.image + '" alt="" loading="lazy">' : '') +
          '</a><div class="product-card__body"><h3 class="product-card__title"><a href="' + item.url + '">' + item.title + '</a></h3>' +
          '<div class="product-card__price"><span class="price"><span class="price__regular">' + item.price + '</span></span></div></div></div>';
      }).join("");
    }
  }

  /* ================================================================
     STAT COUNT-UP — animates numbers with a leading integer when scrolled into view
     ================================================================ */
  if ("IntersectionObserver" in window) {
    var statEls = qsa(".hero__stat b, .stat-strip b");
    var statIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        statIo.unobserve(entry.target);
        var el = entry.target;
        var raw = el.textContent.trim();
        var match = raw.match(/^([\d,]+)(.*)$/);
        if (!match) return;
        var target = parseInt(match[1].replace(/,/g, ""), 10);
        var suffix = match[2];
        if (isNaN(target)) return;
        var start = 0;
        var duration = 900;
        var startTime = null;
        function tick(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(start + (target - start) * eased);
          el.textContent = current.toLocaleString("en-IN") + suffix;
          if (progress < 1) requestAnimationFrame(tick);
          else el.textContent = raw;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    statEls.forEach(function (el) { statIo.observe(el); });
  }


  /* ================================================================
     HOVER ZOOM on product images (desktop pointer only)
     ================================================================ */
  if (window.matchMedia("(hover:hover) and (pointer:fine)").matches) {
    qsa(".pdp-gallery__zoomable").forEach(function (z) {
      var img = z.querySelector("img");
      if (!img) return;
      z.addEventListener("mouseenter", function () { z.classList.add("is-hoverzoom"); });
      z.addEventListener("mouseleave", function () {
        z.classList.remove("is-hoverzoom");
        img.style.transformOrigin = "center center";
      });
      z.addEventListener("mousemove", function (e) {
        if (!z.classList.contains("is-hoverzoom")) return;
        var r = z.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + "% " + y + "%";
      });
    });
  }

  /* ================================================================
     SHARE — native share sheet + copy link
     ================================================================ */
  function shareToast(msg) {
    var t = qs("#share-toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-visible");
    setTimeout(function () { t.classList.remove("is-visible"); }, 1800);
  }
  document.addEventListener("click", function (e) {
    var nat = e.target.closest("[data-share-native]");
    if (nat) {
      var url = nat.getAttribute("data-url"), title = nat.getAttribute("data-title");
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { shareToast("Link copied"); });
      }
      return;
    }
    var cp = e.target.closest("[data-copy-link]");
    if (cp) {
      var u = cp.getAttribute("data-url");
      if (navigator.clipboard) {
        navigator.clipboard.writeText(u).then(function () { shareToast("Link copied"); });
      } else {
        var ta = document.createElement("textarea");
        ta.value = u; document.body.appendChild(ta); ta.select();
        try { document.execCommand("copy"); shareToast("Link copied"); } catch (err) {}
        document.body.removeChild(ta);
      }
    }
  });

  /* ================================================================
     HELP WIDGET — guided FAQ, no third-party script
     ================================================================ */
  var chatFab = qs("#chat-fab"), chatPanel = qs("#chat-panel");
  if (chatFab && chatPanel) {
    var chatOpts = qs("#chat-opts"), chatBody = qs("#chat-body");
    var topics = window.RP_CHAT_TOPICS || [];

    function renderTopics() {
      chatOpts.innerHTML = topics.map(function (t, i) {
        return '<button type="button" class="chat-opt" data-chat-topic="' + i + '">' + t.q + "</button>";
      }).join("");
    }
    renderTopics();

    chatFab.addEventListener("click", function () {
      var open = chatPanel.classList.toggle("is-open");
      chatFab.setAttribute("aria-expanded", open ? "true" : "false");
    });
    var chatClose = qs("#chat-close");
    if (chatClose) chatClose.addEventListener("click", function () {
      chatPanel.classList.remove("is-open");
      chatFab.setAttribute("aria-expanded", "false");
    });

    chatOpts.addEventListener("click", function (e) {
      var b = e.target.closest("[data-chat-topic]");
      if (!b) return;
      var t = topics[parseInt(b.getAttribute("data-chat-topic"), 10)];
      if (!t) return;
      var wrap = document.createElement("div");
      wrap.innerHTML =
        '<div class="chat-msg chat-msg--user">' + t.q + "</div>" +
        '<div class="chat-msg">' + t.a +
          (t.cta ? '<br><a href="' + t.cta.href + '" style="display:inline-block;margin-top:8px;font-weight:700;color:var(--rp-blue-2)">' + t.cta.label + " →</a>" : "") +
        "</div>";
      chatOpts.parentNode.insertBefore(wrap, chatOpts);
      chatBody.scrollTop = chatBody.scrollHeight;
    });
  }


  /* ================================================================
     COOKIE CONSENT — wired to Shopify's Customer Privacy API
     ================================================================ */
  var cookieBanner = qs("#cookie-banner");
  if (cookieBanner) {
    var CK = "rp_cookie_consent";
    var stored = null;
    try { stored = localStorage.getItem(CK); } catch (e) {}

    function applyConsent(accepted) {
      try { localStorage.setItem(CK, accepted ? "accepted" : "declined"); } catch (e) {}
      // Tell Shopify about the choice when the Privacy API is available
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
            function () {}
          );
        } catch (e) {}
      }
      cookieBanner.classList.remove("is-visible");
      setCookieOpen(false);
    }

    function setCookieOpen(on) {
      document.body.classList.toggle("cookie-open", on);
      if (on) {
        // Feed the real measured height to CSS so nothing overlaps it
        document.documentElement.style.setProperty("--cookie-h", cookieBanner.offsetHeight + "px");
      } else {
        document.documentElement.style.removeProperty("--cookie-h");
      }
    }
    if (!stored) {
      setTimeout(function () {
        cookieBanner.classList.add("is-visible");
        setCookieOpen(true);
        window.addEventListener("resize", function () {
          if (document.body.classList.contains("cookie-open")) {
            document.documentElement.style.setProperty("--cookie-h", cookieBanner.offsetHeight + "px");
          }
        }, { passive: true });
      }, 1200);
    }
    cookieBanner.addEventListener("click", function (e) {
      var b = e.target.closest("[data-cookie]");
      if (!b) return;
      var action = b.getAttribute("data-cookie");
      if (action === "dismiss") {
        // Close without recording a choice; ask again next visit
        cookieBanner.classList.remove("is-visible");
        setCookieOpen(false);
        return;
      }
      applyConsent(action === "accept");
    });
  }

  /* ================================================================
     ANNOUNCEMENT BAR — simple rotation if multiple slides
     ================================================================ */
  var annSlides = qsa("[data-announcement-slide]");
  if (annSlides.length > 1) {
    var annIndex = 0;
    // Cross-fade in place (absolute stacking) so rotation never changes the
    // announcement bar height and never shifts the sticky header below it.
    annSlides.forEach(function (el, i) {
      el.style.position = i === 0 ? "relative" : "absolute";
      el.style.left = 0; el.style.right = 0;
      el.style.transition = "opacity .4s ease";
      el.style.opacity = i === 0 ? "1" : "0";
      el.style.pointerEvents = i === 0 ? "" : "none";
      el.classList.remove("hidden");
    });
    setInterval(function () {
      var prev = annSlides[annIndex];
      annIndex = (annIndex + 1) % annSlides.length;
      var next = annSlides[annIndex];
      prev.style.opacity = "0"; prev.style.pointerEvents = "none"; prev.style.position = "absolute";
      next.style.opacity = "1"; next.style.pointerEvents = ""; next.style.position = "relative";
    }, 4200);
  }
})();
